import { Injectable } from '@angular/core';
import { CommonAction } from './common.action';
import { ListService } from '../component/list/list.service';
var ApiAction = /** @class */ (function () {
    function ApiAction(commonAction, listService) {
        this.commonAction = commonAction;
        this.listService = listService;
        this.rec = {};
        this.compRec = {};
        this.response = {};
        this.request = {};
    }
    ApiAction.prototype.setInit = function () {
        this.listService.initQuery();
    };
    ApiAction.prototype.getRec = function () {
        return this.request ? this.request : this.rec;
    };
    ApiAction.prototype.getUrl = function (params, response, rec, compRec, queryGroupName) {
        var _params = JSOG.parse(JSON.stringify(params));
        this.response = response;
        this.rec = rec;
        this.compRec = compRec;
        this.queryGroupName = queryGroupName;
        _params = this.commonAction.replaceParams(_params, this.response, this.rec);
        var url = _params.url;
        var queryParams = null;
        if (url.match(/(\?query)/)) {
            url = url.replace(RegExp.$1, '');
            queryParams = { query: JSON.stringify(this.mergeQuery(_params)) };
        }
        if (typeof _params.dataComponent !== 'undefined') {
            this.rec = this.getRequestData(_params.dataComponent);
        }
        this.setRequest(_params);
        return {
            params: _params,
            url: url,
            rec: this.getRec(),
            query: queryParams
        };
    };
    ApiAction.prototype.mergeQuery = function (params) {
        var groupName;
        if (typeof params.groupName !== 'undefined') {
            groupName = params.groupName;
        }
        else if (this.queryGroupName) {
            groupName = this.queryGroupName;
        }
        var requestQuery = JSOG.parse(JSON.stringify(this.listService.getQuery({}, groupName)));
        if (typeof params.query !== 'undefined') {
            var query = params.query;
            if (typeof query.limit !== 'undefined') {
                requestQuery.limit = query.limit;
            }
            if (typeof query.offset !== 'undefined') {
                requestQuery.offset = query.offset;
            }
            if (typeof query.orderByList !== 'undefined') {
                for (var _i = 0, _a = query.orderByList; _i < _a.length; _i++) {
                    var order = _a[_i];
                    var paths = jsonpath.paths(requestQuery, '$.orderByList[?(@.name=="' + order.name + '")]')[0];
                    if (paths && typeof paths[2] !== 'undefined') {
                        requestQuery.orderByList.splice(paths[2], 1);
                    }
                }
                requestQuery.orderByList = query.orderByList.concat(requestQuery.orderByList);
            }
            if (typeof query.predicateList !== 'undefined') {
                for (var _b = 0, _c = query.predicateList; _b < _c.length; _b++) {
                    var predicate = _c[_b];
                    var paths = jsonpath.paths(requestQuery, '$.predicateList[?(@.name=="' + predicate.name + '")]')[0];
                    if (paths && typeof paths[2] !== 'undefined') {
                        requestQuery.predicateList.splice(paths[2], 1);
                    }
                }
                requestQuery.predicateList = query.predicateList.concat(requestQuery.predicateList);
            }
        }
        return requestQuery;
    };
    ApiAction.prototype.setRequest = function (params) {
        var request = params.request;
        this.request = null;
        if (typeof request !== 'undefined' && request instanceof Array && request.length > 0) {
            for (var _i = 0, request_1 = request; _i < request_1.length; _i++) {
                var req = request_1[_i];
                if (typeof req.dataComponent !== 'undefined') {
                    req.data = this.getRequestData(req.dataComponent);
                    delete req.dataComponent;
                }
                else if (typeof req.listDataComponent !== 'undefined') {
                    req.listData = this.getRequestData(req.listDataComponent);
                    delete req.listDataComponent;
                }
                if (typeof req.groupName !== 'undefined' || typeof req.query !== 'undefined') {
                    req.query = this.mergeQuery(Object.assign(new Api(), { groupName: req.groupName, query: req.query }));
                }
                if (typeof req.groupName !== 'undefined') {
                    delete req.groupName;
                }
            }
            this.request = { request: request };
        }
    };
    ApiAction.prototype.getDataComponent = function (component) {
        var components = [];
        if (typeof component === 'string') {
            components.push(component);
        }
        else if (Array.isArray(component)) {
            components = component;
        }
        return components;
    };
    ApiAction.prototype.getRequestData = function (component) {
        var components = this.getDataComponent(component);
        var rec = {};
        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
            var component_1 = components_1[_i];
            var reg = new RegExp('^' + component_1 + '$');
            for (var _a = 0, _b = Object.keys(this.compRec); _a < _b.length; _a++) {
                var key = _b[_a];
                if (key.match(reg)) {
                    Object.assign(rec, this.compRec[key]);
                }
            }
        }
        return rec;
    };
    ApiAction.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ApiAction.ctorParameters = function () { return [
        { type: CommonAction },
        { type: ListService }
    ]; };
    return ApiAction;
}());
export { ApiAction };
var Api = /** @class */ (function () {
    function Api() {
    }
    return Api;
}());
var Request = /** @class */ (function () {
    function Request() {
    }
    return Request;
}());
var ApiParams = /** @class */ (function () {
    function ApiParams() {
    }
    return ApiParams;
}());
//# sourceMappingURL=api.action.js.map